import React from 'react';
import { Col, Row } from 'react-bootstrap';
import './ExtraSec2.css'

const ExtraSec2 = () => {
    return (
       <Row  style={{backgroundColor:"#5ab1d0",marginTop:"3rem",paddingBottom:"5rem"}}>
           <Col className="round">
                <div class="box">
                    <img src="https://i.ibb.co/HKLWwMD/step-2.jpg" alt=""/>
                    <h3>choose your favorite food</h3>
                </div>
           </Col>
           <Col>
                <div className="box">
                    <img src="https://i.ibb.co/5hd1t2s/step-1.jpg" alt="" />
                    <h3>Free & Fast delivery</h3>
                </div></Col>
           <Col>
                <div className="box">
                    <img src="https://i.ibb.co/mHzbSbL/step-3.jpg" alt="" />
                    <h3>easy payment methods</h3>
                </div>
           </Col>
           <Col>
                <div className="box">
                    <img src="https://i.ibb.co/pZQK5SF/step-4.jpg" alt="" />
                    <h3>enjoy your favourite food</h3>
                </div>
           </Col>
       </Row>
    );
};

export default ExtraSec2;
<section className="steps">
                <div className="box">
                    <img src="https://i.ibb.co/HKLWwMD/step-2.jpg" alt="" />
                    <h3>Choose your favourite food</h3>
                </div>
                
                
               
            </section>